module.exports = __webpack_public_path__ + "fonts/barlow-v5-latin-700.99202e6.woff2";